const en = {
    "app.page.user.title": "users",
    "app.page.user.sendInvite": "send an invitation",
    "app.page.user.email": "email",
    "app.page.user.selectRole": "select the role",
    "app.page.user.send": "send",
    "app.page.user.residentsData": "information about residents",
    "app.page.user.name": "name",
    "app.page.user.post": "email",
    "app.page.user.phone": "phone",
    "app.page.user.role": "role",
    "app.page.user.more": "show more",
    "app.page.user.roleAssignment": "role assignment",
    "app.page.user.removeSelected": "remove selection",
    "app.page.user.delete": "delete",
    "app.page.user.modal.title": "delete account",
    "app.page.user.modal.content": "are you sure you want to delete the account(s)?",
    "app.page.user.modal.delete": "delete",
    "app.page.user.modal.cancel": "cancel",
    "app.page.appRole.title": "roles",
    "app.page.appRole.businessObjectAndRoles.businessObject": "business object",
    "app.page.appRole.businessObjectAndRoles.roles": "roles",
    "app.page.appRole.businessObjectAndRoles.admin_console": "access to the admin console",
    "app.page.appRole.businessObjectAndRoles.cabinet": "access to the cabinet",
    "app.page.appRole.businessObjectAndRoles.user": "user",
    "app.page.appRole.businessObjectAndRoles.app_role": "app role",
    "app.page.appRole.businessObjectAndRoles.meal": "meal",
    "app.page.appRole.businessObjectAndRoles.recipe": "recipe",
    "app.page.appRole.businessObjectAndRoles.recipe_type": "recipe type",
    "app.page.appRole.businessObjectAndRoles.product": "product",
    "app.page.appRole.businessObjectAndRoles.product_scheme": "product scheme",
    "app.page.appRole.businessObjectAndRoles.preference": "preference",
    "app.page.appRole.businessObjectAndRoles.user_preference": "user preference",
    "app.page.appRole.businessObjectAndRoles.auth": "auth",
    "app.page.appRole.businessObjectAndRoles.object": "object",
    "app.page.product.title": "Products",
    "app.page.product.filter": "filter",
    "app.page.product.addProduct": "add product",
    "app.page.product.addProductSmall": "add",
    "app.page.product.saveChanges": "save changes",
    "app.page.product.saveChangesSmall": "save",
    "app.page.product.editProduct": "edit product",
    "app.page.product.selectFromList": "select a value from the list",
    "app.page.product.minValue": "minimal value",
    "app.page.product.maxValue": "maximum value",
    "app.page.product.productSearch": "product search",
    "app.page.product.formSearch": "form search",
    "app.page.product.addForm": "add form",
    "app.page.product.downloadCSV": "export to csv",
    "app.page.product.exportingCSV": "exporting...",
    "app.page.product.form.downloadCSV": "export to csv",
    "app.page.product.property.downloadCSV": "export to csv",
    "app.page.recipe.downloadCSV": "export to csv",
    "app.page.product.editForm": "edit form",
    "app.page.product.addProperty": "add property",
    "app.page.product.editProperty": "edit property",
    "app.page.product.referenceBook": "reference book",
    "app.page.product.referenceBookNone": "not set",
    "app.page.product.add": "add",
    "app.page.product.compositionBasis": "composition basis",
    "app.page.product.variantKind": "variant kind",
    "app.page.product.flourGrainKind": "flour grain",
    "app.page.product.flourMillingGrade": "flour grade",
    "app.page.product.variants": "variants",
    "app.page.product.related": "related",
    "app.page.product.compositionCheck.title": "macro composition completeness",
    "app.page.product.compositionCheck.loading": "checking…",
    "app.page.product.compositionCheck.provenance": "reference book",
    "app.page.product.compositionCheck.hint": "soft warnings only; save, import and generate are not blocked",
    "app.page.product.compositionCheck.status.complete": "complete",
    "app.page.product.compositionCheck.status.partial": "partial",
    "app.page.product.compositionCheck.status.not-comparable": "not comparable",
    "app.page.product.compositionCheck.branch.protein": "protein",
    "app.page.product.compositionCheck.branch.fat": "fat",
    "app.page.product.compositionCheck.branch.carbohydrate": "carbohydrate",
    "app.page.product.compositionCheck.rule.protein_aa_sum": "amino-acid sum {{sum}} g/100 g exceeds protein {{parent}} (tolerance {{tolerance}})",
    "app.page.product.compositionCheck.rule.fat_subtotal_sum": "SFA+MUFA+PUFA {{sum}} g/100 g exceeds fat {{parent}} (tolerance {{tolerance}})",
    "app.page.product.compositionCheck.rule.sugars_sum": "sugar sum {{sum}} g/100 g exceeds total-sugars {{parent}} (tolerance {{tolerance}})",
    "app.page.product.compositionCheck.rule.starch_sum": "amylose+amylopectin {{sum}} g/100 g exceeds starch {{parent}} (tolerance {{tolerance}})",
    "app.page.product.close": "close",
    "app.page.product.productFormName": "product form",
    "app.page.product.addFormItem.formName": "Form name",
    "app.page.product.addFormItem.formCode": "Form code",
    "app.page.product.addFormItem.formGroup": "Form group",
    "app.page.product.addFormItem.formType": "Form type",
    "app.page.product.productTab.product": "products",
    "app.page.product.productTab.form": "forms",
    "app.page.product.productTab.property": "properties",
    "app.page.product.productFormTab.physical": "physical properties",
    "app.page.product.productFormTab.macronutrient": "macronutrient",
    "app.page.product.productFormTab.micronutrient": "micronutrient",
    "app.page.product.addProductItem.productName": "Product name",
    "app.page.product.addProductItem.productCode": "Product code",
    "app.page.product.pagination.first": "first",
    "app.page.product.pagination.last": "last",
    "app.page.product.modal.close": "close",
    "app.page.product.modal.form.title": "delete form",
    "app.page.product.modal.form.content": "are you sure you want to delete the form?",
    "app.page.product.modal.form.delete": "delete",
    "app.page.product.modal.form.cancel": "cancel",
    "app.page.product.modal.item.title": "delete product",
    "app.page.product.modal.item.content": "are you sure you want to delete the product?",
    "app.page.product.modal.item.delete": "delete",
    "app.page.product.modal.item.cancel": "cancel",
    "app.page.product.modal.property.title": "delete property",
    "app.page.product.modal.property.content": "are you sure you want to delete the property?",
    "app.page.product.modal.property.delete": "delete",
    "app.page.product.modal.property.cancel": "cancel",
    "app.page.product.filters.fat": "fat",
    "app.page.product.filters.proteins": "proteins",
    "app.page.product.filters.carbohydrates": "carbohydrates",
    "app.page.product.filters.mineralsValue": "minerals value",
    "app.page.product.filters.vitaminsValue": "vitamins value",
    "app.page.product.filters.type": "type",
    "app.page.product.filters.form": "form",
    "app.page.product.filters.color": "color",
    "app.page.product.filters.energy": "energy",
    "app.page.product.filters.cancel": "cancel",
    "app.page.product.filters.applyFilter": "apply filter",
    "app.page.product.propertyItem.propertyType": "property type",
    "app.page.product.propertyItem.categoryName": "category name",
    "app.page.product.propertyItem.propertyName": "property name",
    "app.page.product.propertyItem.propertyCode": "property code",
    "app.page.product.propertyItem.values": "values",
    "app.page.product.propertyItem.selectValues": "enter values",
    "app.page.product.propertyItem.description": "description",
    "app.page.product.propertyItem.synonyms": "Display synonyms",
    "app.page.product.propertyItem.text": "text",
    "app.page.preference.title": "preferences",
    "app.page.preference.filter": "filter",
    "app.page.preference.addPreference": "add preference",
    "app.page.preference.savePreference": "save preference",
    "app.page.preference.addPreferenceSmall": "add",
    "app.page.preference.savePreferenceSmall": "save",
    "app.page.preference.selectFromList": "select a value from the list",
    "app.page.preference.preferenceSearch": "preference search",
    "app.page.preference.enterInfo": "enter information",
    "app.page.preference.editPreference": "edit preference",
    "app.page.preference.applyFilter": "apply filter",
    "app.page.preference.cancel": "cancel",
    "app.page.preference.preferenceAssignment": "preference assignment",
    "app.page.preference.userSearch": "search a user",
    "app.page.preference.userName": "name",
    "app.page.preference.userPhone": "phone",
    "app.page.preference.selected": "Selected",
    "app.page.preference.preference": "preference",
    "app.page.preference.preferences": "preferences",
    "app.page.preference.total": "Total",
    "app.page.preference.assignGroup": "assign group",
    "app.page.preference.assignUser": "assign user",
    "app.page.preference.modal.title": "delete preference",
    "app.page.preference.modal.content": "are you sure you want to delete the preference?",
    "app.page.preference.modal.delete": "delete",
    "app.page.preference.modal.cancel": "cancel",
    "app.page.preference.modal.assign": "assign",
    "app.page.preference.addTitles.include": "I want/I dont want",
    "app.page.preference.addTitles.preferenceType": "What do I want?",
    "app.page.preference.addTitles.when": "When?",
    "app.page.preference.addTitles.isInternal": "Is internal?",
    "app.page.preference.addTitles.whichGroup": "Which group?",
    "app.page.preference.addTitles.phrase": "Phrase",
    "app.page.preference.addTitles.preferenceLabels": "Which group?",
    "app.page.recipe.title": "Recipes",
    "app.page.generation-trace.title": "Meal generation",
    "app.page.generationTrace.title": "Meal generation traces",
    "app.page.generationTrace.back": "Back to list",
    "app.page.generationTrace.userId": "User ID",
    "app.page.generationTrace.outcome": "Outcome",
    "app.page.generationTrace.anyOutcome": "Any outcome",
    "app.page.generationTrace.skipReason": "Skip reason",
    "app.page.generationTrace.applyFilters": "Apply",
    "app.page.generationTrace.from": "From",
    "app.page.generationTrace.to": "To",
    "app.page.generationTrace.empty": "No traces yet",
    "app.page.generationTrace.total": "Total",
    "app.page.generationTrace.createdAt": "Created",
    "app.page.generationTrace.mealType": "Type",
    "app.page.generationTrace.recipeId": "Recipe ID",
    "app.page.generationTrace.mealId": "Meal ID",
    "app.page.generationTrace.targetKcal": "Target kcal",
    "app.page.generationTrace.actualKcal": "Actual kcal",
    "app.page.generationTrace.open": "Open",
    "app.page.generationTrace.summary": "Summary",
    "app.page.generationTrace.timeline": "Timeline",

    "app.page.reference-books.title": "Reference books",
    "app.page.menu.collapse": "Collapse menu",
    "app.page.menu.expand": "Expand menu",
    "app.page.svg-library.title": "SVG library",
    "app.page.svg-library.hint": "Shared illustrations for products. Edit in Draw and save to the library.",
    "app.page.svg-library.new": "New",
    "app.page.svg-library.newTitle": "New SVG asset",
    "app.page.svg-library.editTitle": "Edit SVG asset",
    "app.page.svg-library.search": "Search",
    "app.page.svg-library.searchPlaceholder": "Search by title or code",
    "app.page.svg-library.empty": "No assets yet",
    "app.page.svg-library.back": "Back to library",
    "app.page.svg-library.saving": "Saving…",
    "app.page.svg-library.titlePlaceholder": "Title",
    "app.page.svg-library.tagsPlaceholder": "Tags (comma-separated)",
    "app.page.svg-library.untitled": "Untitled",
    "app.page.svg-library.untitledContour": "Contour",
    "app.page.svg-library.unsavedConfirm": "You have unsaved changes. Leave anyway?",
    "app.page.svg-library.svgTooLarge": "SVG exceeds {{max}} KB",
    "app.page.svg-library.chapdrawTooLarge": "Draft exceeds {{max}} MB",
    "app.page.svg-library.saveError": "Could not save asset",
    "app.page.svg-library.loadError": "Could not load asset",
    "app.page.svg-library.conflict": "Asset was changed elsewhere. Reload and try again.",
    "app.page.svg-library.reload": "Reload",
    "app.page.svg-library.allTags": "All tags",
    "app.page.svg-library.downloadSvg": "Download SVG",
    "app.page.svg-library.downloadChapdraw": "Download .chapdraw",
    "app.page.product.edit.svg.title": "Illustrations",
    "app.page.product.edit.svg.hint": "Attach one or more assets from the SVG library. One must be primary.",
    "app.page.product.edit.svg.add": "Add from library",
    "app.page.product.edit.svg.primary": "Primary",
    "app.page.product.edit.svg.setPrimary": "Set primary",
    "app.page.product.edit.svg.detach": "Detach",
    "app.page.product.edit.svg.openDraw": "Open in Draw",
    "app.page.product.edit.svg.empty": "No illustrations attached",
    "app.page.product.edit.svg.pick": "Select an asset to attach",
    "app.page.product.edit.svg.up": "Up",
    "app.page.product.edit.svg.down": "Down",
    "app.page.recipe.edit.svg.title": "Illustrations",
    "app.page.recipe.edit.svg.hint": "Attach one or more assets from the SVG library. One must be primary.",
    "app.page.recipe.edit.svg.add": "Add from library",
    "app.page.recipe.edit.svg.primary": "Primary",
    "app.page.recipe.edit.svg.setPrimary": "Set primary",
    "app.page.recipe.edit.svg.detach": "Detach",
    "app.page.recipe.edit.svg.openDraw": "Open in Draw",
    "app.page.recipe.edit.svg.empty": "No illustrations attached",
    "app.page.recipe.edit.svg.pick": "Select an asset to attach",
    "app.page.recipe.edit.svg.up": "Up",
    "app.page.recipe.edit.svg.down": "Down",
    "app.page.grain-liquid-ratios.title": "Grain/liquid ratios",
    "app.page.grain-liquid-ratios.hint": "Reference ratios for porridge: product or category × consistency × liquid. Cooking-step amounts are derived from these values.",
    "app.page.grain-liquid-ratios.exportCsv": "Export CSV",
    "app.page.grain-liquid-ratios.importCsv": "Import CSV",
    "app.page.grain-liquid-ratios.addTitle": "New ratio",
    "app.page.grain-liquid-ratios.addHint": "Provide a product code or a category (both allowed). Liquid defaults to water.",
    "app.page.grain-liquid-ratios.create": "Add",
    "app.page.grain-liquid-ratios.edit": "Edit",
    "app.page.grain-liquid-ratios.save": "Save",
    "app.page.grain-liquid-ratios.cancel": "Cancel",
    "app.page.grain-liquid-ratios.delete": "Delete",
    "app.page.grain-liquid-ratios.empty": "No ratios yet",
    "app.page.grain-liquid-ratios.columns.actions": "Actions",
    "app.page.grain-liquid-ratios.importSuccess": "Import complete: upserted {{count}}",
    "app.page.grain-liquid-ratios.importFailed": "CSV import failed",
    "app.page.grain-liquid-ratios.fields.productCode": "Product",
    "app.page.grain-liquid-ratios.fields.productCodePlaceholder": "e.g. rice",
    "app.page.grain-liquid-ratios.product.empty": "Not set",
    "app.page.grain-liquid-ratios.fields.productCategory": "Category",
    "app.page.grain-liquid-ratios.fields.consistencyCode": "Consistency",
    "app.page.grain-liquid-ratios.fields.liquidKind": "Liquid",
    "app.page.grain-liquid-ratios.fields.liquidPerGrain": "Liquid per 1 part grain",
    "app.page.grain-liquid-ratios.fields.liquidPerGrainPlaceholder": "e.g. 2",
    "app.page.grain-liquid-ratios.fields.basis": "Basis",
    "app.page.grain-liquid-ratios.columns.product": "Product",
    "app.page.grain-liquid-ratios.columns.category": "Category",
    "app.page.grain-liquid-ratios.columns.consistency": "Consistency",
    "app.page.grain-liquid-ratios.columns.liquid": "Liquid",
    "app.page.grain-liquid-ratios.columns.ratio": "Ratio",
    "app.page.grain-liquid-ratios.columns.basis": "Basis",
    "app.page.grain-liquid-ratios.liquid.water": "Water",
    "app.page.grain-liquid-ratios.liquid.milk": "Milk",
    "app.page.grain-liquid-ratios.liquid.plant-milk": "Plant milk",
    "app.page.grain-liquid-ratios.liquid.any": "Any",
    "app.page.grain-liquid-ratios.liquid.kindCollapse.plant-milk": "Collapse: plant milk",
    "app.page.grain-liquid-ratios.liquid.kindCollapse.any": "Collapse: any",
    "app.page.grain-liquid-ratios.basis.volume": "Volume",
    "app.page.grain-liquid-ratios.basis.mass": "Mass",
    "app.page.grain-liquid-ratios.category.empty": "Not set",
    "app.page.grain-liquid-ratios.category.grain": "Grain",
    "app.page.grain-liquid-ratios.validation.productOrCategory": "Provide a product code or a category",
    "app.page.grain-liquid-ratios.validation.consistencyRequired": "Select a consistency",
    "app.page.grain-liquid-ratios.validation.liquidRequired": "Select a liquid",
    "app.page.grain-liquid-ratios.validation.ratioPositive": "Ratio must be greater than 0",
    "app.page.grain-liquid-ratios.validation.basisInvalid": "Select volume or mass",
    "app.page.referenceBooks.title": "Reference books",
    "app.page.referenceBooks.listHint": "Composition reference books and chemical composition tables.",
    "app.page.referenceBooks.backToList": "Back to list",
    "app.page.referenceBooks.backToBook": "Back to book",
    "app.page.referenceBooks.code": "Code",
    "app.page.referenceBooks.bookTitle": "Title",
    "app.page.referenceBooks.tableTitle": "Table",
    "app.page.referenceBooks.kind": "Kind",
    "app.page.referenceBooks.status": "Status",
    "app.page.referenceBooks.year": "Year",
    "app.page.referenceBooks.authors": "Authors / editors",
    "app.page.referenceBooks.tables": "Tables",
    "app.page.referenceBooks.tablesCount": "Tables",
    "app.page.referenceBooks.tableKind": "Table kind",
    "app.page.referenceBooks.rowsCount": "Rows",
    "app.page.referenceBooks.open": "Open",
    "app.page.referenceBooks.label": "Label",
    "app.page.referenceBooks.rowKind": "Row kind",
    "app.page.referenceBooks.heatHint": "Heat hint",
    "app.page.referenceBooks.protein": "Protein %",
    "app.page.referenceBooks.fat": "Fat %",
    "app.page.referenceBooks.carb": "Carbs %",
    "app.page.referenceBooks.basis": "Basis",
    "app.page.referenceBooks.searchPlaceholder": "Search by label or code",
    "app.page.referenceBooks.applyFilters": "Apply",
    "app.page.referenceBooks.downloadCsv": "Download CSV",
    "app.page.referenceBooks.total": "Total",
    "app.page.referenceBooks.prev": "Previous",
    "app.page.referenceBooks.next": "Next",
    "app.page.referenceBooks.pageRange": "{{from}}–{{to}} of {{total}}",
    "app.page.referenceBooks.boolean.true": "yes",
    "app.page.referenceBooks.boolean.false": "no",
    "app.page.referenceBooks.rowKindValue.product": "product",
    "app.page.referenceBooks.rowKindValue.category": "category",
    "app.page.referenceBooks.rowKindValue.recipe": "recipe",
    "app.page.referenceBooks.col.page": "Page",
    "app.page.referenceBooks.col.table_no": "Table",
    "app.page.referenceBooks.col.code": "Code",
    "app.page.referenceBooks.col.label": "Label",
    "app.page.referenceBooks.col.is_category": "Category",
    "app.page.referenceBooks.col.water_pct": "Water %",
    "app.page.referenceBooks.col.protein_pct": "Protein %",
    "app.page.referenceBooks.col.fat_pct": "Fat %",
    "app.page.referenceBooks.col.sfa_pct": "SFA %",
    "app.page.referenceBooks.col.chol_mg_pct": "Chol. mg%",
    "app.page.referenceBooks.col.mds_pct": "MDS %",
    "app.page.referenceBooks.col.starch_pct": "Starch %",
    "app.page.referenceBooks.col.carb_pct": "Carbs %",
    "app.page.referenceBooks.col.fiber_pct": "Fiber %",
    "app.page.referenceBooks.col.org_acid_pct": "Org. acids %",
    "app.page.referenceBooks.col.ash_pct": "Ash %",
    "app.page.referenceBooks.col.na_mg_pct": "Na mg%",
    "app.page.referenceBooks.col.pufa_pct": "PUFA %",
    "app.page.referenceBooks.col.row_kind": "Kind",
    "app.page.referenceBooks.col.is_recipe": "Recipe",
    "app.page.referenceBooks.col.chapche_product_code": "Product code",
    "app.page.referenceBooks.col.chapche_recipe_code": "Recipe code",
    "app.page.referenceBooks.col.heat_treatment_hint": "Heat treatment",
    "app.page.referenceBooks.col.notes": "Notes",
    "app.page.referenceBooks.col.k_mg_pct": "K mg%",
    "app.page.referenceBooks.col.ca_mg_pct": "Ca mg%",
    "app.page.referenceBooks.col.mg_mg_pct": "Mg mg%",
    "app.page.referenceBooks.col.p_mg_pct": "P mg%",
    "app.page.referenceBooks.col.fe_mg_pct": "Fe mg%",
    "app.page.referenceBooks.col.vit_a_ug_pct": "A µg%",
    "app.page.referenceBooks.col.carotene_ug_pct": "Carotene µg%",
    "app.page.referenceBooks.col.re_ug_pct": "RE µg%",
    "app.page.referenceBooks.col.te_mg_pct": "TE mg%",
    "app.page.referenceBooks.col.b1_mg_pct": "B1 mg%",
    "app.page.referenceBooks.col.b2_mg_pct": "B2 mg%",
    "app.page.referenceBooks.col.pp_mg_pct": "PP mg%",
    "app.page.referenceBooks.col.ne_mg_pct": "NE mg%",
    "app.page.referenceBooks.col.vit_c_mg_pct": "C mg%",
    "app.page.referenceBooks.col.energy_kcal": "Energy kcal",
    "app.page.referenceBooks.col.fdc_id": "FDC id",
    "app.page.referenceBooks.col.ndb_number": "NDB",
    "app.page.referenceBooks.col.food_category": "FDC category",
    "app.page.referenceBooks.col.food_category_id": "Category id",
    "app.page.referenceBooks.col.publication_date": "Publication date",
    "app.page.referenceBooks.col.energy": "Energy",
    "app.page.referenceBooks.col.moisture": "Moisture",
    "app.page.referenceBooks.col.protein": "Protein",
    "app.page.referenceBooks.col.fat": "Fat",
    "app.page.referenceBooks.col.carbohydrate": "Carbohydrate",
    "app.page.referenceBooks.col.alimentary-fiber": "Fiber",
    "app.page.referenceBooks.col.sugar": "Sugar",
    "app.page.referenceBooks.col.total-ash": "Ash",
    "app.page.referenceBooks.col.saturated-fatty-acids": "SFA",
    "app.page.referenceBooks.col.monounsaturated-fatty-acids": "MUFA",
    "app.page.referenceBooks.col.polyunsaturated-fatty-acids": "PUFA",
    "app.page.referenceBooks.col.cholesterol": "Cholesterol",
    "app.page.referenceBooks.col.sodium": "Sodium",
    "app.page.referenceBooks.col.potassium": "Potassium",
    "app.page.referenceBooks.col.calcium": "Calcium",
    "app.page.referenceBooks.col.magnesium": "Magnesium",
    "app.page.referenceBooks.col.phosphorus": "Phosphorus",
    "app.page.referenceBooks.col.ferrum": "Iron",
    "app.page.referenceBooks.col.zinc": "Zinc",
    "app.page.referenceBooks.col.cuprum": "Copper",
    "app.page.referenceBooks.col.selenium": "Selenium",
    "app.page.referenceBooks.col.vitamin-a": "Vitamin A",
    "app.page.referenceBooks.col.beta-carotene": "β-carotene",
    "app.page.referenceBooks.col.ascorbic-acid": "Vitamin C",
    "app.page.referenceBooks.col.thiamine": "Thiamine",
    "app.page.referenceBooks.col.riboflavin": "Riboflavin",
    "app.page.referenceBooks.col.niacin": "Niacin",
    "app.page.referenceBooks.col.pyridoxine": "Pyridoxine",
    "app.page.referenceBooks.col.folic-acid": "Folic acid",
    "app.page.referenceBooks.col.tocopherol-equivalent": "Tocopherol",
    "app.page.referenceBooks.col.vitamin-b12": "Vitamin B12",
    "app.page.referenceBooks.col.vitamin-d": "Vitamin D",
    "app.page.referenceBooks.col.vitamin-k": "Vitamin K",
    "app.page.recipe.recipeTab.item": "recipes",
    "app.page.recipe.recipeTab.cookingStep": "cooking steps",
    "app.page.recipe.recipeSearch": "recipe search",
    "app.page.recipe.recipeCode": "recipe code",
    "app.page.recipe.base": "main ingredients",
    "app.page.recipe.adds": "additional ingredients",
    "app.page.recipe.addsShort": "additional",
    "app.page.recipe.tasty": "tasty ingredients",
    "app.page.recipe.tastyShort": "tasty",
    "app.page.recipe.liquid": "liquid",
    "app.page.recipe.liquidShort": "liquid",
    "app.page.recipe.liquidHint": "One liquid is chosen for the meal (grams from grain∶liquid ratio).",
    "app.page.recipe.defaultKashaConsistency": "default kasha consistency",
    "recipe.scheme.kashaConsistency.fluffy": "fluffy",
    "recipe.scheme.kashaConsistency.creamy": "creamy",
    "recipe.scheme.kashaConsistency.sticky": "sticky",
    "preference.scheme.preferenceType.kasha-consistency": "kasha consistency",
    "preference.scheme.preferenceItem.kasha-consistency-fluffy": "fluffy",
    "preference.scheme.preferenceItem.kasha-consistency-creamy": "creamy",
    "preference.scheme.preferenceItem.kasha-consistency-sticky": "sticky",
    "app.page.recipe.groupShare": "group share, %",
    "app.page.recipe.unitWeight": "unit relative weight",
    "app.page.recipe.heatTreatment": "heat treatment",
    "app.page.recipe.heatTreatment.none": "not specified",
    "app.page.recipe.heatTreatment.raw": "raw",
    "app.page.recipe.heatTreatment.boiled": "boiled",
    "app.page.recipe.heatTreatment.steamed": "steamed",
    "app.page.recipe.heatTreatment.baked": "baked",
    "app.page.recipe.heatTreatment.roasted": "roasted",
    "app.page.recipe.heatTreatment.broiled": "broiled",
    "app.page.recipe.heatTreatment.fried": "fried",
    "app.page.recipe.heatTreatment.sauteed": "sauteed",
    "app.page.recipe.heatTreatment.stewed": "stewed",
    "app.page.recipe.heatTreatment.poached": "poached",
    "app.page.recipe.heatTreatment.microwaved": "microwaved",
    "app.page.recipe.heatTreatment.dried": "dried",
    "app.page.recipe.heatTreatment.sous-vide": "sous vide",
    "app.page.recipe.heatTreatment.pressure-cooked": "pressure cooked",
    "app.page.recipe.amountKind": "measure",
    "app.page.recipe.amountKind.teaspoon": "teaspoon",
    "app.page.recipe.amountKind.pinch": "pinch",
    "app.page.recipe.amountKind.to_taste": "to taste",
    "app.page.recipe.amountKind.gram": "gram",
    "app.page.recipe.amountValue": "amount",
    "app.page.recipe.addProduct": "add product",
    "app.page.recipe.product": "product",
    "app.page.recipe.productState": "product state",
    "app.page.recipe.productCode": "product code",
    "app.page.recipe.addRecipe": "add recipe",
    "app.page.recipe.saveChanges": "save changes",
    "app.page.recipe.editRecipe": "edit recipe",
    "app.page.recipe.name": "name",
    "app.page.recipe.filter": "filter",
    "app.page.recipe.applyFilter": "apply filter",
    "app.page.recipe.cancel": "cancel",
    "app.page.recipe.modal.title": "delete recipe",
    "app.page.recipe.modal.content": "are you sure you want to delete the recipe?",
    "app.page.recipe.modal.delete": "delete",
    "app.page.recipe.modal.cancel": "cancel",
    "app.page.meal.title": "Meals",
    "app.page.plan.title": "My plan",
    "app.page.plan.emptyPlan": "There is no meal plan.",
    "app.page.plan.createPlan": "Create new meal plan",
    "app.page.plan.generatePlan": "Make a plan to eat something",
    "app.page.plan.create": "Create",
    "app.page.plan.toEat": "a plan to eat something",
    "app.page.plan.forWeek": " plan for",
    "app.page.profile.title": "profile",
    "app.page.profile.myData": "my data",
    "app.page.profile.history": "history",
    "app.page.profile.email": "email",
    "app.page.profile.name": "name",
    "app.page.profile.timezone": "timezone",
    "app.page.profile.password": "password",
    "app.page.profile.change": "change",
    "app.page.profile.emptyData": "no data",
    "app.page.profile.changePassword": "change password",
    "app.page.profile.changeEmail": "change email",
    "app.page.profile.wrongPassword": "wrong password",
    "app.page.profile.confirmEmail": "Need to confirm email",
    "app.page.profile.lastName": "last name",
    "app.page.profile.firstName": "first name",
    "app.page.profile.middleName": "middle name",
    "app.page.profile.phone": "phone",
    "app.page.profile.changePhone": "change phone",
    "app.page.profile.modalCabinet.title": "Enter a new number",
    "app.page.profile.modalCabinet.content": "We will send a verification code to it.",
    "app.page.profile.modalCabinet.cancel": "Cancel",
    "app.page.profile.modalCabinet.change": "Get code",
    "app.page.profile.modal.email.title": "Enter a new email",
    "app.page.profile.modal.email.content": "We will send a confirmation email to it",
    "app.page.profile.modal.email.change": "change",
    "app.page.profile.modal.email.cancel": "cancel",
    "app.page.profile.modal.password.title": "Change Password",
    "app.page.profile.modal.password.content": "Fill in all fields",
    "app.page.profile.modal.password.change": "change",
    "app.page.profile.modal.password.cancel": "cancel",
    "app.page.profile.modal.password.currentPassword": "current password",
    "app.page.profile.modal.password.newPassword": "new password",
    "app.page.profile.modal.password.repeatNewPassword": "repeat new password",
    "product.scheme.form.code.paste-nut": "paste",
    "product.item.code.hazelnut": "hazelnut",
    "app.page.modal.close": "close",
    "app.page.pagination.first": "first",
    "app.page.pagination.last": "last",
    "appRoles.scheme.userRoles.guest": "guest",
    "appRoles.scheme.userRoles.app-user": "app user",
    "appRoles.scheme.userRoles.admin": "admin",
    "appRoles.scheme.permissions.createPermission": "create",
    "appRoles.scheme.permissions.deletePermission": "delete",
    "appRoles.scheme.permissions.modifyAllPermission": "modify all",
    "appRoles.scheme.permissions.readPermission": "read",
    "appRoles.scheme.permissions.updatePermission": "update",
    "appRoles.scheme.permissions.viewAllPermission": "view all",
    "preference.scheme.include.true": "include",
    "preference.scheme.include.false": "exclude",
    "preference.scheme.preferenceType.recipe": "recipe",
    "preference.scheme.preferenceType.product": "product",
    "preference.scheme.preferenceType.property": "property",
    "preference.scheme.preferenceLabels.basic": "basic",
    "preference.scheme.preferenceLabels.favorites": "favorites",
    "preference.scheme.preferenceLabels.season": "season",
    "preference.scheme.when.morning": "morning",
    "preference.scheme.when.after-morning": "after-morning",
    "preference.scheme.when.afternoon": "afternoon",
    "preference.scheme.when.before-evening": "before-evening",
    "preference.scheme.when.evening": "evening",
    "preference.scheme.when.night": "night",
    "preference.scheme.when.whole-day": "whole-day",
    "preference.scheme.isInternal.true": "yes",
    "preference.scheme.isInternal.false": "no",
    "ingredient.scheme.ingredientForm.liquid": "liquid",
    "ingredient.scheme.ingredientForm.boiled": "boiled",
    "ingredient.scheme.ingredientForm.smallCrashed": "smallCrashed",
    "ingredient.scheme.ingredientForm.paste": "paste",
    "ingredient.scheme.ingredientForm.raw": "raw",
    "ingredient.scheme.ingredientForm.sliced": "sliced",
    "ingredient.scheme.ingredientForm.ground": "ground",
    "ingredient.scheme.ingredientForm.dried": "dried",
    "ingredient.scheme.ingredientForm.sauce": "sauce",
    "ingredient.scheme.ingredientForm.thick": "thick",
    "ingredient.scheme.ingredientForm.steamed": "steamed",
    "ingredient.scheme.ingredientForm.fried": "fried",
    "ingredient.scheme.ingredientForm.sous-vide": "sous-vide",
    "ingredient.scheme.ingredientForm.softBoiled": "softBoiled",
    "ingredient.scheme.ingredientForm.roast": "roast",
    "ingredient.scheme.ingredientForm.canned": "canned",
    "ingredient.scheme.ingredientForm.toasted": "toasted",
    "ingredient.scheme.ingredientForm.poached": "poached",
    "ingredient.scheme.ingredientForm.salted": "salted",
    "ingredient.scheme.ingredientForm.spread": "spread",
    "ingredient.scheme.ingredientForm.ball": "ball",
    "ingredient.scheme.ingredientForm.filing": "filing",
    "ingredient.scheme.ingredientForm.baked": "baked",
    "ingredient.scheme.ingredientForm.grated": "grated",
    "recipe.scheme.recipeType.snack": "snack",
    "recipe.scheme.recipeType.smoothies": "smoothies",
    "recipe.scheme.recipeType.granola": "granola",
    "recipe.scheme.recipeType.bread": "bread",
    "recipe.scheme.recipeType.kasha": "kasha",
    "recipe.scheme.recipeType.bowl": "bowl",
    "recipe.scheme.recipeType.soup": "soup",
    "meal.scheme.mealType.snack": "snack",
    "meal.scheme.mealType.smoothies": "smoothies",
    "meal.scheme.mealType.granola": "granola",
    "meal.scheme.mealType.bread": "bread",
    "meal.scheme.mealType.kasha": "kasha",
    "meal.scheme.mealType.bowl": "bowl",
    "meal.scheme.mealType.soup": "soup",
    "meal.scheme.mealTime.breakfast": "breakfast",
    "meal.scheme.mealTime.lunch": "lunch",
    "meal.scheme.mealTime.dinner": "dinner",
    "meal.scheme.mealTime.snack": "snack",
    "product.scheme.productForm.flesh": "flesh",
    "product.scheme.productForm.pulp": "pulp",
    "product.scheme.productForm.with-skin": "with-skin",
    "product.scheme.productForm.whole-grain": "whole-grain",
    "product.scheme.productForm.bran": "bran",
    "product.scheme.productForm.tolokno": "tolokno",
    "product.scheme.productForm.flour": "flour",
    "product.scheme.productForm.raw": "raw",
    "product.scheme.productForm.fry": "fry",
    "product.scheme.productForm.any": "any",
    "product.scheme.formType.product-part": "product part",
    "product.scheme.formType.heatTreatment": "heat treatment",
    "product.scheme.formGroup.grain": "grain",
    "product.scheme.formGroup.vegetable": "vegetable",
    "product.scheme.formGroup.meat": "meat",
    "product.scheme.property.propertyType.string": "string",
    "product.scheme.property.propertyType.number": "number",
    "product.scheme.property.propertyType.select": "select",
    "product.scheme.property.propertyType.boolean": "boolean",
    "product.scheme.property.propertyName.pulp": "pulp",
    "product.scheme.property.propertyName.with_skin": "with_skin",
    "product.scheme.property.propertyName.without_skin": "without_skin",
    "product.scheme.property.propertyName.raw": "raw",
    "product.scheme.property.propertyName.boiled": "boiled",
    "product.scheme.property.propertyName.from": "from",
    "product.scheme.property.propertyName.to": "to",
    "product.scheme.property.propertyName.vitamins": "vitamins",
    "product.scheme.property.propertyName.season": "season",
    "product.scheme.property.propertyName.vegetable": "vegetable",
    "product.scheme.property.propertyName.fruit": "fruit",
    "product.scheme.property.propertyName.berry": "berry",
    "product.scheme.property.propertyName.salad": "salad",
    "product.scheme.property.propertyName.meat": "meat",
    "product.scheme.property.propertyName.fish": "fish",
    "product.scheme.property.propertyName.grain": "grain",
    "product.scheme.property.propertyName.cereal": "cereal",
    "product.scheme.property.propertyName.color": "color",
    "product.scheme.property.propertyName.aspartic-acid": "aspartic-acid",
    "product.scheme.property.propertyName.butyric-acid": "butyric-acid",
    "product.scheme.property.propertyName.caproic-acid": "caproic-acid",
    "product.scheme.property.propertyName.caprylic-acid": "caprylic-acid",
    "product.scheme.property.propertyName.capric-acid": "capric-acid",
    "product.scheme.property.propertyName.lauric-acid": "lauric-acid",
    "product.scheme.property.propertyName.myristic-acid": "myristic-acid",
    "product.scheme.property.propertyName.pentadecanoic-acid": "pentadecanoic-acid",
    "product.scheme.property.propertyName.palmitic-acid": "palmitic-acid",
    "product.scheme.property.propertyName.margaric-acid": "margaric-acid",
    "product.scheme.property.propertyName.stearic-acid": "stearic-acid",
    "product.scheme.property.propertyName.arachidic-acid": "arachidic-acid",
    "product.scheme.property.propertyName.behenic-acid": "behenic-acid",
    "product.scheme.property.propertyName.lignoceric-acid": "lignoceric-acid",
    "product.scheme.property.propertyName.cerotic-acid": "cerotic-acid",
    "product.scheme.property.propertyName.riboflavin": "riboflavin",
    "product.scheme.property.propertyName.niacin": "niacin",
    "product.scheme.property.propertyName.pantothenic-acid": "pantothenic-acid",
    "product.scheme.property.propertyName.vitamin-b6": "vitamin-b6",
    "product.scheme.property.propertyName.biotin": "biotin",
    "product.scheme.property.propertyName.protein": "protein",
    "product.scheme.property.propertyName.linoleic-acid": "linoleic-acid",
    "product.scheme.property.propertyName.alfa-linolenic-acid": "alfa-linolenic-acid",
    "product.scheme.property.propertyName.stearidonic-acid": "stearidonic-acid",
    "product.scheme.property.propertyName.arachidonic-acid": "arachidonic-acid",
    "product.scheme.property.propertyName.timnodonic-acid": "timnodonic-acid",
    "product.scheme.property.propertyName.clupanodonic-acid": "clupanodonic-acid",
    "product.scheme.property.propertyName.cervonic-acid": "cervonic-acid",
    "product.scheme.property.propertyName.ribose": "ribose",
    "product.scheme.property.propertyName.amylose": "amylose",
    "product.scheme.property.propertyName.amylopectin": "amylopectin",
    "product.scheme.property.propertyName.B": "B",
    "product.scheme.property.propertyName.Ca": "Ca",
    "product.scheme.property.propertyName.Co": "Co",
    "product.scheme.property.propertyName.Cr": "Cr",
    "product.scheme.property.propertyName.Cu": "Cu",
    "product.scheme.property.propertyName.Fe": "Fe",
    "product.scheme.property.propertyName.I": "I",
    "product.scheme.property.propertyName.K": "K",
    "product.scheme.property.propertyName.Mg": "Mg",
    "product.scheme.property.propertyName.Mn": "Mn",
    "product.scheme.property.propertyName.Mo": "Mo",
    "product.scheme.property.propertyName.Na": "Na",
    "product.scheme.property.propertyName.P": "P",
    "product.scheme.property.propertyName.Se": "Se",
    "product.scheme.property.propertyName.Zn": "Zn",
    "product.scheme.property.propertyName.vitamin-a": "vitamin-a",
    "product.scheme.property.propertyName.thiamine": "thiamine",
    "product.scheme.property.propertyName.folate": "folate",
    "product.scheme.property.propertyName.cobalamin": "cobalamin",
    "product.scheme.property.propertyName.vitamin-c": "vitamin-c",
    "product.scheme.property.propertyName.vitamin-d": "vitamin-d",
    "product.scheme.property.propertyName.vitamin-e": "vitamin-e",
    "product.scheme.property.propertyName.vitamin-k": "vitamin-k",
    "product.scheme.property.propertyName.moisture": "moisture",
    "product.scheme.property.propertyName.fiber": "fiber",
    "product.scheme.property.propertyName.alanine": "alanine",
    "product.scheme.property.propertyName.agrinine": "agrinine",
    "product.scheme.property.propertyName.asparagine": "asparagine",
    "product.scheme.property.propertyName.cysteine": "cysteine",
    "product.scheme.property.propertyName.glutamic-acid": "glutamic-acid",
    "product.scheme.property.propertyName.glutamine": "glutamine",
    "product.scheme.property.propertyName.glycine": "glycine",
    "product.scheme.property.propertyName.histidine": "histidine",
    "product.scheme.property.propertyName.isoleucine": "isoleucine",
    "product.scheme.property.propertyName.leucine": "leucine",
    "product.scheme.property.propertyName.lysine": "lysine",
    "product.scheme.property.propertyName.methionine": "methionine",
    "product.scheme.property.propertyName.phenylalanine": "phenylalanine",
    "product.scheme.property.propertyName.proline": "proline",
    "product.scheme.property.propertyName.serine": "serine",
    "product.scheme.property.propertyName.threonine": "threonine",
    "product.scheme.property.propertyName.tryptophan": "tryptophan",
    "product.scheme.property.propertyName.tyrosine": "tyrosine",
    "product.scheme.property.propertyName.valine": "valine",
    "product.scheme.property.propertyName.fat": "fat",
    "product.scheme.property.propertyName.starch": "starch",
    "product.scheme.property.propertyName.saturated-fatty-acids": "saturated-fatty-acids",
    "product.scheme.property.propertyName.monounsaturated-fatty-acids": "monounsaturated-fatty-acids",
    "product.scheme.property.propertyName.myristol": "myristol",
    "product.scheme.property.propertyName.pentadecenoic": "pentadecenoic",
    "product.scheme.property.propertyName.palmitoyl": "palmitoyl",
    "product.scheme.property.propertyName.heptadecenoic": "heptadecenoic",
    "product.scheme.property.propertyName.oleic-acid": "oleic-acid",
    "product.scheme.property.propertyName.eicosen": "eicosen",
    "product.scheme.property.propertyName.erucic-acid": "erucic-acid",
    "product.scheme.property.propertyName.nervonic-acid": "nervonic-acid",
    "product.scheme.property.propertyName.polyunsaturated-fatty-acids": "polyunsaturated-fatty-acids",
    "product.scheme.property.propertyName.carbohydrate": "carbohydrate",
    "product.scheme.property.propertyName.total-sugars": "total-sugars",
    "product.scheme.property.propertyName.glucose": "glucose",
    "product.scheme.property.propertyName.sucrose": "sucrose",
    "product.scheme.property.propertyName.maltose": "maltose",
    "product.scheme.property.propertyName.galactose": "galactose",
    "product.scheme.property.propertyName.fructose": "fructose",
    "product.scheme.property.propertyName.lactose": "lactose",
    "product.scheme.property.propertyName.antioxidant": "antioxidant",
    "product.scheme.property.propertyName.total-ash": "total-ash",
    "product.scheme.property.propertyName.minerals": "minerals",
    "product.scheme.property.propertyName.carotene": "carotene",
    "product.scheme.property.propertyName.choline": "choline",
    "product.scheme.property.propertyName.energy": "energy",
    "product.scheme.property.propertyName.liquidKind": "liquid kind",
    "product.scheme.property.propertyName.black": "black",
    "product.scheme.property.propertyName.yellow": "yellow",
    "product.scheme.property.propertyName.orange": "orange",
    "product.scheme.property.propertyName.blue": "blue",
    "product.scheme.property.propertyName.red": "red",
    "product.scheme.property.propertyName.green": "green",
    "product.scheme.property.propertyName.white": "white",
    "product.scheme.property.propertyName.purple": "purple",
    "product.scheme.property.propertyName.violet": "violet",
    "product.scheme.productCode.carrot": "carrot",
    "product.scheme.productCode.potato": "potato",
    "product.scheme.productCode.apple": "apple",
    "product.scheme.productCode.orange": "orange",
    "product.scheme.productCode.tomato": "tomato",
    "product.scheme.productCode.melon": "melon",
    "product.scheme.productCode.watermelon": "watermelon",
    "product.scheme.productCode.cucumber": "cucumber",
    "product.scheme.productCode.tomat": "tomat",
    "product.scheme.productCode.toast": "toast",
    "product.scheme.productCode.banana": "banana",
    "product.scheme.productCode.oat": "oat",
    "product.scheme.productCode.salmon": "salmon",
    "days.scheme.daysOfWeek.su": "su",
    "days.scheme.daysOfWeek.mo": "mo",
    "days.scheme.daysOfWeek.tu": "tu",
    "days.scheme.daysOfWeek.we": "we",
    "days.scheme.daysOfWeek.th": "th",
    "days.scheme.daysOfWeek.fr": "fr",
    "days.scheme.daysOfWeek.sa": "sa",
    "days.scheme.months.January": "January",
    "days.scheme.months.February": "February",
    "days.scheme.months.March": "March",
    "days.scheme.months.April": "April",
    "days.scheme.months.May": "May",
    "days.scheme.months.June": "June",
    "days.scheme.months.July": "July",
    "days.scheme.months.August": "August",
    "days.scheme.months.September": "September",
    "days.scheme.months.October": "October",
    "days.scheme.months.November": "November",
    "days.scheme.months.December": "December",
    "app.page.preference.deleteCount": "There must be a minimum of 5 preferences. To delete an existing preference, first create a new one",
    "app.page.preference.item": "preferences",
    "product.item.code.almond": "almond",
    "product.item.code.peanut": "peanut",
    "app.page.product.productUnitMcg": "mcg",
    "app.page.product.productUnitMcgTitle": "mcg (microgram)",
    "app.page.product.productUnitMg": "mg",
    "app.page.product.productUnitMgTitle": "mg (milligram)",
    "app.page.product.productUnitG": "g",
    "app.page.product.productUnitGTitle": "g (gramme)",
    "preference.scheme.when.now": "now",
    "preference.scheme.when.today": "today",
    "preference.scheme.when.tomorrow": "tomorrow",
    "preference.scheme.when.week": "week",
    "app.page.onboarding.regenerate": "The recipe can be regenerated",
    "app.page.onboarding.orChange": "or changed",
    "app.page.onboarding.nutritionReport": "The nutrition report will show the amount of nutrients in the diet",
    "app.page.onboarding.eatingHabits": "Indicate your eating habits:",
    "app.page.onboarding.chapcheCreate": "Chapche create a meal plan based on your food preferences",
    "app.page.onboarding.title": "Welcome",
    "app.page.onboarding.to": "to",
    "app.page.onboarding.myPlan": "My plan",
    "app.page.onboarding.back": "Back",
    "app.page.onboarding.continue": "Continue",
    "app.page.onboarding.finish": "Finish",
    "app.page.product.updated": "Updated",
    "app.page.product.min": "min",
    "app.page.product.hour": "h",
    "app.page.product.ago": "ago",
    "product.item.code.walnut": "walnut",
    "product.item.code.apricot": "apricot",
    "product.item.code.carrot": "carrot",
    "product.item.code.potato": "potato",
    "product.item.code.apple": "apple",
    "product.item.code.orange": "orange",
    "product.item.code.tomato": "tomato",
    "product.item.code.melon": "melon",
    "product.item.code.watermelon": "watermelon",
    "product.item.code.cucumber": "cucumber",
    "product.item.code.tomat": "tomat",
    "product.item.code.toast": "toast",
    "product.item.code.banana": "banana",
    "product.item.code.oat": "oat",
    "product.item.code.salmon": "salmon",
    "product.scheme.form.code.any": "any",
    "product.scheme.form.code.pulp": "pulp",
    "product.scheme.form.code.with-skin": "with-skin",
    "product.scheme.form.code.bran": "bran",
    "product.scheme.form.code.tolokno": "tolokno",
    "product.scheme.form.code.flour": "flour",
    "product.scheme.form.code.starch": "starch",
    "product.scheme.form.code.liquid": "liquid",
    "product.scheme.form.code.raw": "raw",
    "product.scheme.form.code.fry": "fry",
    "product.scheme.form.code.without_skin": "without-skin",
    "product.scheme.form.code.boiled": "boiled",
    "product.scheme.form.code.flesh": "flesh",
    "app.page.recipe.ingredientForm": "ingredient form",
    "product.scheme.property.code.pulp": "pulp",
    "product.scheme.property.code.with_skin": "with_skin",
    "product.scheme.property.code.without_skin": "without_skin",
    "product.scheme.property.code.raw": "raw",
    "product.scheme.property.code.boiled": "boiled",
    "product.scheme.property.code.from": "from",
    "product.scheme.property.code.to": "to",
    "product.scheme.property.code.vitamins": "vitamins",
    "product.scheme.property.code.season": "season",
    "product.scheme.property.code.vegetable": "vegetable",
    "product.scheme.property.code.fruit": "fruit",
    "product.scheme.property.code.berry": "berry",
    "product.scheme.property.code.salad": "salad",
    "product.scheme.property.code.meat": "meat",
    "product.scheme.property.code.fish": "fish",
    "product.scheme.property.code.grain": "grain",
    "product.scheme.property.code.cereal": "cereal",
    "product.scheme.property.code.color": "color",
    "product.scheme.property.code.butyric-acid": "butyric-acid",
    "product.scheme.property.code.caproic-acid": "caproic-acid",
    "product.scheme.property.code.caprylic-acid": "caprylic-acid",
    "product.scheme.property.code.capric-acid": "capric-acid",
    "product.scheme.property.code.lauric-acid": "lauric-acid",
    "product.scheme.property.code.myristic-acid": "myristic-acid",
    "product.scheme.property.code.pentadecanoic-acid": "pentadecanoic-acid",
    "product.scheme.property.code.palmitic-acid": "palmitic-acid",
    "product.scheme.property.code.margaric-acid": "margaric-acid",
    "product.scheme.property.code.stearic-acid": "stearic-acid",
    "product.scheme.property.code.arachidic-acid": "arachidic-acid",
    "product.scheme.property.code.behenic-acid": "behenic-acid",
    "product.scheme.property.code.lignoceric-acid": "lignoceric-acid",
    "product.scheme.property.code.cerotic-acid": "cerotic-acid",
    "product.scheme.property.code.riboflavin": "riboflavin",
    "product.scheme.property.code.niacin": "niacin",
    "product.scheme.property.code.pantothenic-acid": "pantothenic-acid",
    "product.scheme.property.code.vitamin-b6": "vitamin-b6",
    "product.scheme.property.code.biotin": "biotin",
    "product.scheme.property.code.protein": "protein",
    "product.scheme.property.code.alfa-linolenic-acid": "alfa-linolenic-acid",
    "product.scheme.property.code.stearidonic-acid": "stearidonic-acid",
    "product.scheme.property.code.arachidonic-acid": "arachidonic-acid",
    "product.scheme.property.code.timnodonic-acid": "timnodonic-acid",
    "product.scheme.property.code.clupanodonic-acid": "clupanodonic-acid",
    "product.scheme.property.code.cervonic-acid": "cervonic-acid",
    "product.scheme.property.code.ribose": "ribose",
    "product.scheme.property.code.amylose": "amylose",
    "product.scheme.property.code.amylopectin": "amylopectin",
    "product.scheme.property.code.B": "B",
    "product.scheme.property.code.Ca": "Ca",
    "product.scheme.property.code.Co": "Co",
    "product.scheme.property.code.Cr": "Cr",
    "product.scheme.property.code.Cu": "Cu",
    "product.scheme.property.code.Fe": "Fe",
    "product.scheme.property.code.I": "I",
    "product.scheme.property.code.K": "K",
    "product.scheme.property.code.Mg": "Mg",
    "product.scheme.property.code.Mn": "Mn",
    "product.scheme.property.code.Mo": "Mo",
    "product.scheme.property.code.Na": "Na",
    "product.scheme.property.code.P": "P",
    "product.scheme.property.code.Se": "Se",
    "product.scheme.property.code.Zn": "Zn",
    "product.scheme.property.code.thiamine": "thiamine",
    "product.scheme.property.code.folate": "folate",
    "product.scheme.property.code.cobalamin": "cobalamin",
    "product.scheme.property.code.vitamin-c": "vitamin-c",
    "product.scheme.property.code.vitamin-a": "retinol",
    "product.scheme.property.code.aspartic-acid": "aspartic acid",
    "product.scheme.property.code.linoleic-acid": "linoleic acid",
    "product.scheme.property.code.vitamin-d": "vitamin-d",
    "product.scheme.property.code.vitamin-k": "vitamin-k",
    "product.scheme.property.code.moisture": "moisture",
    "product.scheme.property.code.liquidKind": "liquid kind",
    "product.scheme.property.code.fiber": "fiber",
    "product.scheme.property.code.alanine": "alanine",
    "product.scheme.property.code.agrinine": "agrinine",
    "product.scheme.property.code.asparagine": "asparagine",
    "product.scheme.property.code.cysteine": "cysteine",
    "product.scheme.property.code.glutamine": "glutamine",
    "product.scheme.property.code.glycine": "glycine",
    "product.scheme.property.code.histidine": "histidine",
    "product.scheme.property.code.isoleucine": "isoleucine",
    "product.scheme.property.code.leucine": "leucine",
    "product.scheme.property.code.lysine": "lysine",
    "product.scheme.property.code.methionine": "methionine",
    "product.scheme.property.code.phenylalanine": "phenylalanine",
    "product.scheme.property.code.proline": "proline",
    "product.scheme.property.code.serine": "serine",
    "product.scheme.property.code.threonine": "threonine",
    "product.scheme.property.code.tryptophan": "tryptophan",
    "product.scheme.property.code.tyrosine": "tyrosine",
    "product.scheme.property.code.valine": "valine",
    "product.scheme.property.code.fat": "fat",
    "product.scheme.property.code.starch": "starch",
    "app.page.preference.filters": "filters",
    "product.scheme.property.code.monounsaturated-fatty-acids": "monounsaturated-fatty-acids",
    "product.scheme.property.code.myristol": "myristol",
    "product.scheme.property.code.pentadecenoic": "pentadecenoic",
    "product.scheme.property.code.palmitoyl": "palmitoyl",
    "product.scheme.property.code.heptadecenoic": "heptadecenoic",
    "product.scheme.property.code.eicosen": "eicosen",
    "product.scheme.property.code.erucic-acid": "erucic-acid",
    "product.scheme.property.code.nervonic-acid": "nervonic-acid",
    "product.scheme.property.code.polyunsaturated-fatty-acids": "polyunsaturated-fatty-acids",
    "product.scheme.property.code.total-sugars": "total-sugars",
    "product.scheme.property.code.glucose": "glucose",
    "product.scheme.property.code.sucrose": "sucrose",
    "product.scheme.property.code.maltose": "maltose",
    "product.scheme.property.code.galactose": "galactose",
    "product.scheme.property.code.fructose": "fructose",
    "product.scheme.property.code.lactose": "lactose",
    "product.scheme.property.code.antioxidant": "antioxidant",
    "product.scheme.property.code.minerals": "minerals",
    "product.scheme.property.code.carotene": "carotene",
    "product.scheme.property.code.choline": "choline",
    "product.scheme.property.code.energy": "energy",
    "product.scheme.property.code.black": "black",
    "product.scheme.property.code.yellow": "yellow",
    "product.scheme.property.code.orange": "orange",
    "product.scheme.property.code.blue": "blue",
    "product.scheme.property.code.red": "red",
    "product.scheme.property.code.green": "green",
    "product.scheme.property.code.white": "white",
    "product.scheme.property.code.purple": "purple",
    "product.scheme.property.code.violet": "violet",
    "recipe.item.type.snack": "snack",
    "recipe.item.type.smoothies": "smoothies",
    "recipe.item.type.granola": "granola",
    "recipe.item.type.bread": "bread",
    "recipe.item.type.kasha": "kasha",
    "recipe.item.type.bowl": "bowl",
    "recipe.item.type.soup": "soup",
    "app.page.appRole.businessObjectAndRoles.locale": "locale",
    "app.page.product.excludeForm": "Exclude form",
    "app.page.product.formException": "Form exclusion",
    "app.page.product.cancel": "cancel",
    "app.page.product.exclude": "exclude",
    "product.scheme.property.code.carbohydrate": "carbohydrates",
    "product.scheme.property.code.oleic-acid": "oleic acid",
    "product.scheme.property.code.total-ash": "total ash",
    "product.scheme.property.code.glutamic-acid": "glutamic-acid",
    "product.scheme.property.code.vitamin-e": "vitamin e",
    "app.page.product.modal.createProduct.title": "create product code",
    "app.page.product.modal.createProduct.content": "created code cannot be changed",
    "app.page.product.modal.createProduct.cancel": "cancel",
    "app.page.product.modal.createProduct.create": "create",
    "app.page.recipe.modal.createRecipe.title": "select recipe type",
    "app.page.recipe.modal.createRecipe.content": "it can be changed at any time",
    "app.page.recipe.modal.createRecipe.cancel": "cancel",
    "app.page.recipe.modal.createRecipe.create": "create",
    "app.page.recipe.recipeType": "recipe type",
    "app.page.recipe.modal.deleteModal.title": "delete ingredient",
    "app.page.recipe.modal.deleteModal.content": "do you want to remove an ingredient",
    "app.page.recipe.modal.addModal.title": "add product",
    "app.page.recipe.modal.addModal.add": "continue",
    "app.page.recipe.needToFillIngredientForm": "required field",
    "app.page.product.propertySearch": "property search",
    "app.page.product.notFound": "no matches",
    "app.page.product.productFormTab.addProperty": "add property",
    "app.page.product.productFormTab.searchProperties": "properties search",
    "app.page.product.productAddProperty.title": "Enter a property name",
    "app.page.product.productAddProperty.continue": "continue",
    "app.page.product.productAddProperty.cancel": "cancel",
    "product.scheme.property.categoryName.micronutrient": "micronutrient",
    "product.scheme.property.categoryName.macronutrient": "macronutrient",
    "product.scheme.property.categoryName.physical": "physical properties",
    "product.scheme.property.categoryName.vitamin": "vitamins",
    "product.item.code.grape-raw": "grape",
    "app.page.preference.showPreference": "show preferences",
    "app.page.preference.clearAll": "clear all",
    "product.scheme.formGroup.oil-seeds": "oil seeds",
    "product.scheme.form.code.dried-fruit": "dried",
    "product.item.code.sunflower-seeds": "sunflowerseeds",
    "app.page.product.hint": "product used in recipe or ratios",
    "app.page.preference.group": "groups",
    "app.page.preference.meal": "meals",
    "app.page.preference.phrase": "phrases",
    "app.page.product.edit": "edit product",
    "app.page.form.title": "forms",
    "app.page.form.edit": "change form",
    "app.page.form.new": "add form",
    "app.page.property.title": "properties",
    "app.page.property.edit": "change property",
    "app.page.property.new": "add property",
    "app.page.property.composition.openTree": "macro composition tree",
    "app.page.property.composition.backToList": "back to properties",
    "app.page.property.composition.title": "protein, fat and carbohydrate composition",
    "app.page.property.composition.hint": "read-only links; click a property to open its card. edges come from metadata and are not edited here",
    "app.page.property.composition.loading": "loading…",
    "app.page.property.composition.emptyBranch": "no seeded parts",
    "app.page.property.composition.missingRoot": "root property missing from catalog",
    "app.page.property.composition.root.protein": "protein",
    "app.page.property.composition.root.fat": "fat",
    "app.page.property.composition.root.carbohydrate": "carbohydrate",
    "app.page.property.composition.group.proteinAggregates": "aggregates / fractions",
    "app.page.property.composition.group.aminoAcids": "amino acids",
    "app.page.property.composition.group.otherProtein": "other protein parts",
    "app.page.property.composition.group.fatSubtotals": "FA subtotals",
    "app.page.property.composition.group.fattyAcids": "fatty acids",
    "app.page.property.composition.group.saturated-fatty-acids": "saturated FA",
    "app.page.property.composition.group.monounsaturated-fatty-acids": "monounsaturated FA",
    "app.page.property.composition.group.polyunsaturated-fatty-acids": "polyunsaturated FA",
    "app.page.property.composition.group.sugars": "sugars",
    "app.page.property.composition.group.starch": "starch",
    "app.page.property.composition.group.fiber": "fiber",
    "app.page.property.composition.group.otherCarb": "other carbohydrates",
    "app.page.property.composition.badge.essential": "essential",
    "app.page.property.composition.badge.non-essential": "non-essential",
    "app.page.property.composition.badge.conditionally-essential": "conditionally essential",
    "app.page.property.composition.badge.conditionally-non-essential": "conditionally non-essential",
    "app.page.property.composition.badge.efa": "essential FA",
    "app.page.property.composition.badge.saturated": "saturated",
    "app.page.property.composition.badge.unsaturated": "unsaturated",
    "app.page.property.composition.badge.monounsaturated": "monounsaturated",
    "app.page.property.composition.badge.polyunsaturated": "polyunsaturated",
    "app.page.property.composition.badge.trans-fats": "trans fats",
    "app.page.property.composition.badge.monosaccharide": "monosaccharide",
    "app.page.property.composition.badge.mono-and-disaccharide": "mono- and disaccharide",
    "app.page.property.composition.badge.disaccharide": "disaccharide",
    "app.page.property.composition.badge.di-and-polysaccharide": "di- and polysaccharide",
    "app.page.property.composition.badge.polysaccharide": "polysaccharide",
    "app.page.cookingStep.title": "cooking steps",
    "app.page.cookingStep.edit": "edit cooking steps",
    "app.page.cookingStep.new": "add cooking step",
    "app.page.cookingStep.addStep": "add step",
    "app.page.cookingStep.empty": "no cooking steps yet",
    "app.page.cookingStep.emptyForType": "No cooking steps yet for «{{type}}»",
    "app.page.cookingStep.addFirstStep": "add first step",
    "app.page.cookingStep.selectStep": "select a step on the left",
    "app.page.cookingStep.stepsCount": "steps ({{count}})",
    "app.page.cookingStep.detailTitle": "step · {{code}}",
    "app.page.cookingStep.stepCode": "Step code",
    "app.page.cookingStep.stepCodeHint": "Technical latin id, e.g. rinse-grain. Needed by the system; users do not see it.",
    "app.page.cookingStep.stepOrder": "step order",
    "app.page.cookingStep.section.instruction": "Instruction",
    "app.page.cookingStep.section.meta": "System",
    "app.page.cookingStep.section.reminder": "Reminder",
    "app.page.cookingStep.textLocale.ru": "RU",
    "app.page.cookingStep.textLocale.en": "EN",
    "app.page.cookingStep.textForUser.ru": "User-facing text (RU)",
    "app.page.cookingStep.textForUser.en": "User-facing text (EN)",
    "app.page.cookingStep.badge.reminder": "reminder",
    "app.page.cookingStep.badge.conditions": "{{count}} cond.",
    "app.page.cookingStep.badge.always": "always",
    "app.page.cookingStep.dragHandle": "drag to reorder",
    "app.page.cookingStep.saveStatus.saving": "saving…",
    "app.page.cookingStep.saveStatus.saved": "saved",
    "app.page.cookingStep.saveStatus.savedAt": "saved {{time}}",
    "app.page.cookingStep.saveStatus.error": "could not save",
    "app.page.cookingStep.saveStatus.retry": "retry",
    "app.page.cookingStep.textRu": "User-facing text (RU)",
    "app.page.cookingStep.textEn": "User-facing text (EN)",
    "app.page.cookingStep.isReminder": "This is an advance reminder",
    "app.page.cookingStep.reminderKindLabel": "When to remind",
    "app.page.cookingStep.reminderKind.preset": "preset",
    "app.page.cookingStep.reminderKind.offset_hours": "hours before meal",
    "app.page.cookingStep.reminderPresetLabel": "Preset",
    "app.page.cookingStep.reminderPreset.evening_before": "Evening before",
    "app.page.cookingStep.reminderPreset.morning_of": "Morning of the meal day",
    "app.page.cookingStep.reminderOffsetHours": "Hours before the meal",
    "app.page.cookingStep.conditions": "When to show the step",
    "app.page.cookingStep.conditionsAlways": "The step is always shown",
    "app.page.cookingStep.conditionsAndHint": "The step is shown only if all conditions match.",
    "app.page.cookingStep.conditionTypeLabel": "When",
    "app.page.cookingStep.conditionType.product_field": "By product property",
    "app.page.cookingStep.conditionType.product_code": "If the meal includes a product",
    "app.page.cookingStep.conditionType.any_ingredient_group_present": "If an ingredient group is present",
    "app.page.cookingStep.conditionType.kasha_consistency": "If kasha consistency equals",
    "app.page.cookingStep.conditionType.kasha_consistency_in": "If kasha consistency is one of",
    "app.page.cookingStep.kashaConsistencyChipsLabel": "Consistency",
    "app.page.cookingStep.preview.kashaConsistency": "kasha consistency is {{value}}",
    "app.page.cookingStep.preview.kashaConsistencyIn": "kasha consistency is one of: {{values}}",
    "app.page.cookingStep.ingredientGroupLabel": "Group",
    "app.page.cookingStep.ingredientGroup.base": "Base",
    "app.page.cookingStep.ingredientGroup.adds": "Adds",
    "app.page.cookingStep.ingredientGroup.tasty": "Tasty",
    "app.page.cookingStep.ingredientGroup.liquid": "Liquid",
    "app.page.cookingStep.fieldName": "Property",
    "app.page.cookingStep.fieldNameCustom": "Custom property (snake_case)",
    "app.page.cookingStep.operator": "Operator",
    "app.page.cookingStep.value": "Value",
    "app.page.cookingStep.productCode": "Product code",
    "app.page.cookingStep.productCodePlaceholder": "Start typing a code or name…",
    "app.page.cookingStep.productField.before_cooking_rinse_need": "Needs rinse before cooking",
    "app.page.cookingStep.productField.other": "Other…",
    "app.page.cookingStep.bool.yes": "Yes",
    "app.page.cookingStep.bool.no": "No",
    "app.page.cookingStep.groupsChipsLabel": "Groups in the meal",
    "app.page.cookingStep.preview.productField": "if {{group}} «{{property}}» = {{value}}",
    "app.page.cookingStep.preview.productCode": "if the meal includes «{{product}}»",
    "app.page.cookingStep.preview.groupsPresent": "if the meal has {{groups}}",
    "app.page.cookingStep.preview.unknown": "condition",
    "app.page.cookingStep.preview.always": "always",
    "app.page.cookingStep.preview.and": "and",
    "app.page.cookingStep.validation.required": "Required field",
    "app.page.cookingStep.validation.noPlaceholders": "Do not use {{placeholders}} in prose — pick a measure block instead",
    "app.page.cookingStep.validation.stepHasErrors": "Step has incomplete fields",
    "app.page.cookingStep.measureBlockLabel": "Measure block",
    "app.page.cookingStep.measureBlockHint": "A system sentence with volumes and the 1∶N ratio is composed when generating kasha. Textarea is optional prose without numbers.",
    "app.page.cookingStep.measureBlock.none": "none",
    "app.page.cookingStep.measureBlock.grain": "grain",
    "app.page.cookingStep.measureBlock.liquid": "liquid",
    "app.page.cookingStep.measureBlock.both": "both",
    "app.page.cookingStep.addCondition": "Add condition",
    "app.page.cookingStep.addConditionFirst": "Limit with conditions",
    "app.page.cookingStep.removeCondition": "Remove",
    "app.page.cookingStep.modal.cancel": "cancel",
    "app.page.cookingStep.modal.create.title": "add cooking step",
    "app.page.cookingStep.modal.create.create": "create",
    "app.page.cookingStep.modal.delete.title": "delete cooking step",
    "app.page.cookingStep.modal.delete.content": "are you sure you want to delete this cooking step?",
    "app.page.cookingStep.modal.delete.delete": "delete",
    "app.page.preference.edit": "change preference",
    "app.page.preference.new": "add preference",
    "app.page.recipe.edit": "change recipe",
    "app.page.recipe.new": "add recipe",
    "app.page.product.propertyItem.vitamin": "vitamin",
    "app.page.product.propertyItem.type": "type",
    "app.page.product.propertyItem.waterSoluble": "water soluble",
    "app.page.product.propertyItem.fatSoluble": "fat soluble",
    "product.scheme.property.vitamin.waterSoluble": "vitamin water soluble",
    "product.scheme.property.vitamin.fatSoluble": "vitamin fat soluble",
    "app.page.preference.addGroup": "add group",
    "app.page.group.title": "groups",
    "app.page.group.new": "add group",
    "app.page.group.edit": "change group",
    "app.page.product.applyTo": "apply to...",
    "app.page.product.fillAs": "fill as...",
    "app.page.product.modal.updateProperties.title": "applying the property",
    "app.page.product.modal.updateProperties.meaning": "meaning",
    "product.item.code.apricot-dried": "apricot dried",
    "product.scheme.form.code.dried-nut": "dried",
    "product.item.code.pumpkin-seeds": "pumpkin seeds",
    "product.scheme.form.code.dried-berry": "dried",
    "app.page.product.modal.updateProperties.applyTo": "apply to",
    "app.page.product.modal.updateProperties.cancel": "cancel",
    "app.page.product.modal.updateProperties.save": "save",
    "app.page.product.modal.updateProperties.allForms": "all product forms",
    "app.page.product.modal.updateProperties.allProperties": "all product properties",
    "app.page.preference.addTitles.howOften": "how often?",
    "preference.scheme.frequency.no-matter": "no matter",
    "preference.scheme.frequency.everyDay": "every day",
    "preference.scheme.frequency.dayAfterDay": "every other day",
    "preference.scheme.frequency.onceInDays": "once every",
    "preference.scheme.preferenceType.cereal-mix": "cereal mix",
    "app.page.product.notAssigned": "not assigned",
    "app.page.preference.groupName": "group name",
    "app.page.property.hint": "used in a product",
    "app.page.form.hint": "used in a product or proeprty",
    "app.page.product.checkFormError": "form code may only be in Latin letters, numbers and the signs “-” and “_”",
    "app.page.product.checkPropertyError": "property code may only be in Latin letters, numbers and the signs “-” and “_”",
    "app.page.product.modal.createForm.title": "create form code",
    "app.page.product.modal.createProperty.title": "create property code",
    "app.page.product.modal.createForm.content": "created code cannot be changed",
    "app.page.product.modal.createProeprty.content": "created code cannot be changed",
    "app.page.property.vitaminError": "select type",
    "app.page.product.modal.cancel": "cancel",
    "app.page.product.modal.create": "create",
    "app.page.product.checkProductError": "product code may only be in Latin letters, numbers and the signs “-” and “_”",
    "app.page.preference.daysCount": "days count",
    "app.page.product.filters.yellow": "yellow",
    "app.page.product.filters.red": "red",
    "app.page.product.filters.green": "green",
    "app.page.product.filters.black": "black",
    "app.page.product.filters.white": "white",
    "app.page.product.filters.vegetable": "vegetable",
    "app.page.product.filters.fruit": "fruit",
    "app.page.product.filters.berry": "berry",
    "app.page.product.filters.meat": "meat",
    "app.page.product.filters.fish": "fish",
    "app.page.product.filters.formGroup": "form group",
    "app.page.product.filters.formType": "form type",
    "app.page.form.filters.grain": "grain",
    "app.page.form.filters.vegetable": "vegetable",
    "app.page.form.filters.meat": "meat",
    "app.page.form.filters.any": "any",
    "app.page.form.filters.heatTreatment": "heat treatment",
    "app.page.form.filters.product-part": "product part",
    "app.page.product.filters.propertyType": "property type",
    "app.page.property.filters.number": "number",
    "app.page.property.filters.select": "select",
    "app.page.property.filters.boolean": "boolean",
    "app.page.property.filters.string": "string",
    "app.page.product.filters.categoryName": "category",
    "app.page.property.filters.macronutrients": "macronutrients",
    "app.page.property.filters.micronutrients": "micronutrients",
    "app.page.property.filters.physical": "physical",
    "app.page.product.filters.vitamin": "vitamin",
    "app.page.property.filters.notVitamin": "not vitamin",
    "app.page.property.filters.fatSoluble": "fat soluble",
    "app.page.property.filters.waterSoluble": "water soluble",
    "app.page.product.filters.ingredient": "ingredient",
    "app.page.product.filters.include": "include",
    "app.page.preferences.filters.true": "true",
    "app.page.preferences.filters.false": "false",
    "app.page.product.filters.preferenceType": "preference type",
    "app.page.product.filters.group": "preference group",
    "app.page.product.filters.when": "when",
    "app.page.product.filters.isInternal": "is internal",
    "app.page.product.showDeleted": "show deleted",
    "app.page.product.filters.clean": "clean",
    "preference.scheme.when.no-matter": "no matter",
    "preference.scheme.groups.base": "base",
    "preference.scheme.groups.season": "season",
    "preference.scheme.groups.collection": "favorites",
    "preference.scheme.groups.noGroup": "no group",
    "app.page.product.checkCodeExists": "this code already exists",
    "app.page.product.checkCodeDeleted": "the code belongs to a removed product - come up with another code",
    "app.page.preference.newPreference": "new preference",
    "app.page.preference.preferenceAsPhrase": "preference as phrase",
    "app.page.preference.preferenceAsPhrasePlaceholder": "i like to eat kasha in the morning",
    "app.page.preference.preferenceAsPhraseInfo": "after entering «Preference as phrase», «Preference as table» will be filled in automatically",
    "app.page.preference.preferenceAsTable": "preference as table",
    "app.page.preference.preferenceAsTablePlaceholder": "enter or select from list",
    "app.page.preference.preferenceActivityPeriod": "preference is valid only on a specific day",
    "app.page.preference.preferenceAsTableInfo": "after entering «Preference as table», «Preference as phrase» will be filled in automatically",
    "app.page.preference.modal.create": "create",
    "preference.scheme.frequency.onceInWeek": "once a week",
    "preference.scheme.frequency.onceInDay": "once a day",
    "preference.scheme.frequency.onceInTwoDays": "once every 2 days",
    "preference.scheme.frequency.onceInThreeDays": "once every 3 days",
    "preference.scheme.frequency.onceInFourDays": "once every 4 days",
    "preference.scheme.frequency.onceInFiveDays": "once every 5 days",
    "app.page.preference.oftenSelect": "often chosen",
    "app.page.preference.notFound": "nothing was found",
    "app.page.preference.notFoundCode": "цe do not have this yet",
    "app.page.preference.myPreferences": "my preferences",
    "app.page.preference.createPreference": "create preference",
    "app.page.preference.until": "until",
    "app.page.preference.always": "always",
    "app.page.preference.morning": "in the morning",
    "app.page.preference.brunch": "for brunch",
    "app.page.preference.lunch": "for lunch",
    "app.page.preference.afternoon": "in the afternoon",
    "app.page.preference.dinner": "for dinner",
    "app.page.preference.night": "at night",
    "app.page.preference.no-matter": "no matter",
    "app.page.product.restore.modal.item.title": "restore product",
    "app.page.product.restore.modal.form.title": "restore form",
    "app.page.product.restore.modal.property.title": "restore property",
    "app.page.product.restore.modal.item.content": "do you want to restore the product",
    "app.page.product.restore.modal.form.content": "do you want to restore the form",
    "app.page.product.restore.modal.property.content": "do you want to restore the property",
    "app.page.product.modal.restore": "restore",
    "app.page.item.hint": "product used in recipe or ratios",
    "app.page.product.modal.item.forceDelete.content": "do you want to permanently remove the product",
    "app.page.product.modal.form.forceDelete.content": "do you want to permanently remove the form",
    "app.page.product.modal.property.forceDelete.content": "do you want to permanently remove the property",
    "product.scheme.property.code.valueOfData": "value",
    "app.page.product.form.checkCodeDeleted": "the code belongs to a removed form - come up with another code",
    "app.page.product.property.checkCodeDeleted": "the code belongs to a removed property - come up with another code",
    "app.page.preference.addCerealMix": "add cereal mix",
    "app.page.product.property.userPropertyType": "the property is displayed in the user account as:",
    "app.page.product.property.vitaminMineral": "vitamin (mineral)",
    "app.page.product.property.calories": "dish by calorie content",
    "app.page.product.property.pfcPriority": "priority PFC",
    "app.page.product.property.colorDiet": "color diet",
    "product.scheme.form.code.whole-grain": "whole grain",
    "product.scheme.form.code.flakes": "flake",
    "product.scheme.property.code.saturated-fatty-acids": "saturated fatty acids",
    "product.scheme.property.code.organic-acids": "organic acids",
    "product.scheme.property.code.cholesterol": "cholesterol",
    "product.scheme.property.code.mono-and-disaccharides": "mono- and disaccharides",
    "product.scheme.property.code.alimentary-fiber": "alimentary fiber",
    "product.scheme.property.code.na": "sodium",
    "product.scheme.property.code.k": "potassium",
    "product.scheme.property.code.ca": "calcium",
    "product.scheme.property.code.mg": "Magnesium",
    "product.scheme.property.code.p": "Phosphorus",
    "product.scheme.property.code.fe": "Ferrum",
    "product.scheme.property.code.a": "retino",
    "product.scheme.property.code.beta-carotene": "beta-carotene",
    "product.scheme.property.code.retinol-equivalent": "Retinol Equivalent",
    "product.scheme.property.code.tocopherol-equivalent": "Tocopherol Equivalent",
    "product.scheme.property.code.pp": "Niacin",
    "product.scheme.property.code.niacin-equivalent": "niacin equivalent",
    "product.item.code.grape-dried": "grape dried",
    "product.scheme.property.code.c": "Ascorbic acid",
    "product.item.code.strawberry": "strawberry",
    "product.scheme.form.code.cereal": "Cereal",
    "product.item.code.fig": "figs",
    "product.item.code.wheat": "Wheat",
    "product.item.code.flower-honey": "flower honey",
    "product.item.code.rye": "rye",
    "product.item.code.rice": "rice",
    "product.item.code.buckwheat": "buckwheat",
    "product.item.code.fig-dried": "figs dried",
    "product.item.code.kiwi": "kiwi",
    "product.item.code.blueberry": "blueberry",
    "product.item.code.barley": "barle",
    "app.page.preference.groups.isAutoAssigned": "preferences from this group will be assigned to the user upon registration",
    "app.page.preference.groups.always": "always",
    "app.page.preference.groups.activityPeriods": "selected period",
    "app.page.preference.groups.activityRange": "activity range",
    "app.page.preference.groups.from": "from",
    "app.page.preference.groups.to": "to",
    "app.page.preference.groups.placeholder": "dd.mm.",
    "app.page.preference.addTitles.preferenceItemCode": "what exactly?",
    "app.page.preference.addTitles.color": "цвет?",
    "app.page.preference.preferenceAssignGroup": "assign group",
    "app.page.preference.groupItemName": "group name",
    "product.item.code.wheat-whole-grain": "wheat whole grain",
    "app.page.preference.showIsWelcome": "show welcome phrases",
    "product.item.code.wheat-cereal": "Wheat cereal",
    "app.page.product.productUnitKcalTitle": "kcal",
    "app.page.product.productUnitFullMcg": "mcg/100 г",
    "app.page.product.propertyItem.numberUnits": "number units",
    "app.page.recipe.modal.addIngredient.title": "adding an ingredient",
    "app.page.recipe.modal.addIngredient.selectType": "select ingredient type",
    "app.page.preference.noPhrases": "no phrases",
    "app.page.preference.downloadCSV": "download CSV file",
    "app.page.product.filters.activityPeriod": "activity range",
    "product.item.code.rye-whole-grain": "Rye whole grain",
    "app.page.product.filters.isAutoAssigned": "assigned upon registration",
    "product.item.code.rye-flour": "rye flour",
    "product.item.code.turkey-soy-broth": "turkey soy broth",
    "preference.scheme.groups.placeholder": "group search",
    "app.page.preference.groups.modal.title": "delete group",
    "app.page.preference.groups.modal.content": "do you want to delete a group",
    "app.page.preference.enterPhrase": "enter phrase",
    "app.page.product.warningLocaleHint": "title translation is not filled",
    "app.page.listView.tile": "tiles",
    "app.page.listView.table": "table",
    "app.page.listView.ariaLabel": "list view",
    "app.page.listView.tableUnavailable": "table view is available on tablet and wider",
    "app.page.listView.empty": "nothing found",
    "app.page.listView.deleted": "deleted",
    "app.page.listView.name": "name",
    "app.page.listView.code": "code",
    "app.page.listView.status": "status",
    "app.page.listView.actions": "actions",
    "app.page.listView.type": "type",
    "app.page.product.filters.status": "status",
    "product.scheme.filter.isNotValid": "invalid",
    "product.scheme.filter.isDeleted": "deleted",
    "app.page.preference.addInIsWelcome": "add to default set",
    "product.scheme.formGroup.nut": "nut",
    "product.scheme.formGroup.berry": "berry",
    "app.page.preference.phrasesForPreference": "phrases for preference",
    "app.page.preference.generated": "generated",
    "app.page.product.productCategory": "product category",
    "app.page.product.filters.productCategory": "product category",
    "app.page.preference.modal.deletePhrase": "delete phrase",
    "app.page.preference.modal.deletePhraseAgree": "do you want to delete the selected phrase?",
    "product.scheme.formGroup.fruit": "fruit",
    "product.scheme.formGroup.fish": "fish",
    "product.scheme.formGroup.poultry": "poultry",
    "product.scheme.formGroup.any": "any",
    "product.scheme.property.code.ascorbic-acid": "Ascorbic acid",
    "public.app.page.login.registrationPhrase": "registration upon request",
    "app.page.appRole.businessObjectAndRoles.recipe_scheme": "recipe scheme",
    "app.page.appRole.businessObjectAndRoles.preference_scheme": "preference scheme",
    "product.scheme.formGroup.honey": "honey",
    "product.scheme.property.code.ferrum": "ferrum",
    "product.scheme.property.code.phosphorus": "Phosphorus",
    "product.scheme.property.code.magnesium": "Magnesium",
    "product.scheme.property.code.calcium": "calcium",
    "product.scheme.property.code.potassium": "potassium",
    "product.scheme.property.code.sodium": "sodium",
    "public.app.page.login.passwordValidation": "the password must contain letters, numbers and special characters",
    "app.page.preference.mainPreference": "what are your food preferences?",
    "app.page.preference.phrasesGenerateFail": "fill in the missing phrase to the user`s preference",
    "app.page.preference.preferenceGenerateFail": "fill in the missing fields to the user`s preference",
    "product.scheme.property.code.albumins": "albumins",
    "product.scheme.property.code.linolenic-acid": "linolenic acid",
    "product.scheme.property.code.cystine": "cystine",
    "product.scheme.property.code.globulins": "globulins",
    "product.scheme.property.code.albumins-and-globulins": "albumins and globulins",
    "product.scheme.property.code.lecithin": "lecithin",
    "product.scheme.property.code.amino-acid": "amino acid",
    "product.scheme.property.code.unsaturated-fatty-acids": "Unsaturated fatty acids",
    "product.scheme.property.code.arginine": "arginine",
    "product.scheme.property.code.manganese": "manganese",
    "product.scheme.property.code.cuprum": "Cuprum",
    "product.scheme.property.code.folic-acid": "folic acid",
    "product.scheme.property.code.silicon": "Silicon",
    "product.scheme.property.code.sulfur": "sulfur",
    "product.scheme.property.code.aluminum": "aluminum",
    "product.item.code.quinoa": "quinoa",
    "product.scheme.property.code.zinc": "zinc",
    "product.scheme.property.code.sugar": "sugars",
    "product.scheme.property.code.cellulose": "cellulose",
    "product.scheme.property.code.pyridoxine": "pyridoxine",
    "product.item.code.amaranth": "amaranth",
    "product.scheme.property.code.selenium": "selenium",
    "app.page.product.basedOn": "take as a basis",
    "app.page.phrase.title": "phrases",
    "app.page.phrase.edit": "change phrase",
    "product.scheme.property.code.mono-and-polyunsaturated-fatty-acids": "mono and polyunsaturated fatty acids",
    "product.item.code.quinoa-boiled": "quinoa",
    "product.scheme.form.code.flakes-small-flattened": "small flattened flakes",
    "product.scheme.form.code.whole": "Whole",
    "product.scheme.form.code.sliced": "Slice",
    "product.scheme.form.code.mash": "mash",
    "product.scheme.form.code.puree": "Puree",
    "product.scheme.property.code.nitrogen": "Nitrogen",
    "public.app.page.login.passwordsIsNotEqual": "password mismatch",
    "product.scheme.form.code.whole-vegetable": "whole",
    "product.scheme.form.code.sliced-vegetable": "sliced",
    "product.scheme.form.code.mash-vegetable": "mash",
    "product.scheme.form.code.puree-vegetable": "puree",
    "product.scheme.form.code.whole-berry": "whole",
    "product.scheme.form.code.whole-fruit": "whole",
    "product.scheme.form.code.sliced-fruit": "slice",
    "product.scheme.form.code.mash-fruit": "mash",
    "product.scheme.form.code.sliced-berry": "slice",
    "product.scheme.form.code.puree-fruit": "puree",
    "product.scheme.form.code.mash-berry": "mash",
    "product.scheme.form.code.puree-berry": "puree",
    "product.scheme.formGroup.dairy": "dairy",
    "product.scheme.formGroup.legumes": "legumes",
    "product.scheme.formGroup.salad-green": "salad green",
    "product.scheme.formGroup.egg": "egg",
    "product.scheme.formGroup.cheese": "cheese",
    "product.scheme.formGroup.pasta": "pasta",
    "product.scheme.formGroup.oil": "oil",
    "product.scheme.formGroup.spices": "spices",
    "product.scheme.formGroup.sauce": "sauce",
    "product.scheme.formGroup.vinegar": "vinegar",
    "public.app.page.login.title": "login",
    "public.app.page.login.email": "email",
    "public.app.page.login.password": "password",
    "public.app.page.login.continue": "continue",
    "public.app.page.login.passwordCreating": "password creating",
    "public.app.page.login.repeatPassword": "repeat password",
    "public.app.page.login.passwordError": "wrong password",
    "public.app.page.login.signInError": "wrong login or password",
    "public.app.page.login.exit": "sign out",
    "public.app.page.login.sendCode": "We have sent an SMS with a code to your number",
    "public.app.page.login.code": "Code from SMS",
    "public.app.page.login.askAgain": "Request code again via",
    "public.app.page.login.sendAgain": "Send again",
    "public.app.page.login.dontReceive": "SMS not coming",
    "public.app.page.login.phone": "phone",
    "public.app.page.login.or": "or",
    "public.app.page.login.signIn": "Sign in",
    "public.app.page.login.signUp": "Sign up",
    "public.app.page.login.exitCabinet": "Exit",
    "public.app.page.login.data": "my data",
    "public.app.page.login.yourName": "your name",
    "public.app.page.login.signUpButton": "sign up",
    "public.app.page.login.modal.title": " Sign out",
    "public.app.page.login.modal.content": "Are you sure you want to sign out?",
    "public.app.page.login.modal.exit": "sign out",
    "public.app.page.login.modal.cancel": "cancel",
    "public.app.page.login.show": "show",
    "public.app.page.login.hide": "hide",
    "public.app.page.login.capsLock": "Caps lock is on",
    "public.app.page.login.content": "We will send a link to this address to create a new password",
    "public.app.page.login.enterEmail": "Enter email address",
    "public.app.page.login.forgetPassword": "Forget password",
    "public.app.page.login.changePasswordError": "wrong email",
    "public.email.confirm.title": "We are glad that you are now with us!",
    "public.email.confirm.subtitle": "Hello! Thank you for registering.",
    "public.email.confirm.subtitleInfo": "To complete registration, confirm your email or follow the link",
    "public.email.confirm.buttonText": "Confirm email",
    "public.email.confirm.downloadPlan": "Get a plan",
    "public.email.confirm.downloadChapche": "Download Сhapche",
    "public.email.confirm.infoText": "You received this letter because you used our service",
    "public.email.confirm.contacts": "Still have questions? Write",
    "public.email.confirm.emailTheme": "Chapche. You are registered in the Chapche app.",
    "public.email.forgotten.title": "Change password",
    "public.email.forgotten.subtitle": "To successfully change your password, use the button or follow the link",
    "public.email.forgotten.subtitleInfo": "",
    "public.email.forgotten.buttonText": "Change password",
    "public.email.forgotten.downloadPlan": "Get a plan",
    "public.email.forgotten.downloadChapche": "Download Сhapche",
    "public.email.forgotten.infoText": "You received this letter because you used our service",
    "public.email.forgotten.contacts": "Still have questions? Write",
    "public.email.forgotten.emailTheme": "Chapche. Link to reset password.",
    "app.page.plan.select.now": "eat now",
    "app.page.plan.select.today": "eat today",
    "app.page.plan.select.tomorrow": "eat tomorrow",
    "app.page.plan.select.week": "for a week",
    "product.item.code.cashew": "cashew",
    "product.scheme.form.code.whole-nut": "whole",
    "product.scheme.form.code.crushed-nut": "crushed",
    "product.scheme.formGroup.syrup": "syrup",
    "app.page.plan.select.currentDay": "on this day",
    "app.page.plan.select.nextDay": "the next day",
    "preference.scheme.when.currentDay": "on this day",
    "preference.scheme.when.nextDay": "the next day",
    "meal.scheme.mealTime.after-morning": "brunch",
    "meal.scheme.mealTime.before-evening": "afternoon",
    "meal.scheme.mealTime.night": "night",
    "app.page.onboarding.preference": "preference",
    "recipe.scheme.characteristic.taste.taste-sweet": "sweet",
    "recipe.scheme.characteristic.taste.taste-salty": "salty",
    "recipe.scheme.characteristic.taste.taste-sour": "sour",
    "recipe.scheme.characteristic.taste.taste-spicy": "spicy",
    "recipe.scheme.characteristic.taste.taste-bitter": "bitter",
    "recipe.scheme.characteristic.taste.taste-umami": "umami",
    "app.page.recipe.recipeCharacteristic.taste": "taste",
    "preference.scheme.preferenceType.recipe-characteristic": "recipe characteristic",
    "product.item.code.Iceberg-lettuce": "Iceberg lettuce",
    "product.item.code.turkey": "turkey",
    "product.scheme.property.code.chlorine": "Chlorine",
    "product.scheme.property.code.iodine": "iodine",
    "product.scheme.property.code.fluorine": "fluorine",
    "product.scheme.property.code.cobalt": "cobalt",
    "recipe.scheme.characteristic.source.source-chapche": "chapche",
    "recipe.scheme.characteristic.source.source-vkusvill": "vkusvill",
    "app.page.recipe.recipeCharacteristic.source": "source",
    "app.page.recipe.recipeName": "recipe name",
    "recipe.item.type.salad": "Salad",
    "app.page.recipe.take-as-is": "Use recipe as is",
    "product.item.code.chicken": "chicken",
    "product.item.code.egg-chicken": "chicken egg",
    "product.item.code.champignon-mushroom": "champignon",
    "product.item.code.mushroom": "Mushroom",
    "product.scheme.formGroup.mushroom": "mushroom",
    "product.item.code.olive": "oli",
    "product.item.code.rice-vinegar": "rice vinegar",
    "product.item.code.parsley-greens": "parsley greens",
    "product.item.code.onion-green": "onion greens",
    "product.item.code.cilantro": "cilantro",
    "product.item.code.sesame-seeds": "sesame seeds",
    "product.item.code.sunflower-oil": "sunflower oil",
    "product.item.code.soy-sauce": "soy sauce",
    "product.item.code.bulgur": "bulgur",
    "product.item.code.beet-root": "beet",
    "product.item.code.pumpkin": "pumpkin",
    "product.item.code.feta": "fe",
    "product.item.code.arugula": "arugula",
    "product.item.code.spinach": "spinach",
    "product.item.code.chili-pepper": "chili pepper",
    "product.item.code.garlic": "garlic",
    "product.item.code.dill-greens": "dill greens",
    "product.item.code.salt": "salt",
    "product.item.code.sugar": "sugar",
    "product.item.code.green-peas": "green peas",
    "product.item.code.black-pepper": "black pepper",
    "product.item.code.white-cabbage": "white cabbage",
    "product.item.code.sweet-pepper": "sweet pepper",
    "product.item.code.lemon": "lemon",
    "meal.scheme.mealType.salad": "salad",
    "product.item.code.pomegranate": "pomegranate",
    "product.item.code.apple-cider-vinegar": "apple cider vinegar",
    "product.item.code.quail-eggs": "quail egg",
    "product.item.code.onion": "onion",
    "product.item.code.mayonnaise": "mayonnaise",
    "product.item.code.gouda-cheese": "Gouda cheese",
    "product.item.code.chickpeas": "chickpeas",
    "product.item.code.tofu": "tofu",
    "product.item.code.zucchini": "zucchini",
    "product.item.code.radish": "radish",
    "product.item.code.romaine-lettuce": "romaine lettuce",
    "product.item.code.wine-vinegar": "wine vinegar",
    "product.item.code.corn-salad": "corn salad",
    "product.item.code.ginger": "ginger",
    "product.item.code.wheat-noodles": "wheat noodles",
    "product.item.code.beef-broth": "beef broth",
    "product.scheme.property.code.broth": "broth",
    "meal.scheme.mealType.omelette": "omelette",
    "product.item.code.soy-sprouts": "soy sprouts",
    "product.item.code.beef": "beef",
    "product.item.code.milk-cream": "milk cream",
    "product.item.code.seaweed": "seaweed",
    "product.item.code.bacon-shpik": "bacon",
    "product.item.code.bay-leaf": "bay lea",
    "product.item.code.chicken-broth": "chickenbroth",
    "product.item.code.tomato-paste": "tomato paste",
    "product.item.code.table-vinegar": "table vinegar",
    "product.item.code.mushroom-broth": "mushroom broth",
    "product.item.code.cucumber-pickled": "cucumber pickled",
    "product.item.code.turmeric": "turmeric",
    "product.item.code.celery-root": "celeryroot",
    "product.item.code.nutmeg": "nutmeg",
    "product.item.code.rice-noodles": "ricenoodles",
    "product.item.code.mung-sprouts": "mung sprouts",
    "product.item.code.pink-salmon-filet": "pink salmon filet",
    "product.item.code.zander-filet": "zander filet",
    "product.item.code.halibut-filet": "halibut filet",
    "product.item.code.milk": "milk",
    "product.item.code.cinnamon": "cinnamon",
    "product.item.code.water": "Drinking water",
    "recipe.item.type.omelette": "omelette",
    "recipe.scheme.recipeType.omelette": "omelette",
    "recipe.scheme.recipeType.salad": "salad",
    "product.scheme.formGroup.broth": "broth",
    "product.scheme.property.code.water": "water",
    "app.page.product.filters.water": "water",
    "app.page.form.filters.water": "water",
    "product.scheme.formGroup.water": "water",
    "product.scheme.formGroup.liquid": "liquid",
    "product.item.code.milk-lactose-free": "milk lactose free",
    "product.item.code.almond-milk": "almond milk",
    "product.item.code.millet": "millet",
    "product.item.code.butter": "butter",
    "product.item.code.parmesan-cheese": "parmesan cheese",
    "product.item.code.pesto-sauce": "pesto sauce",
    "product.item.code.peas-sprouts": "peassprouts",
    "product.item.code.coconut-pulp": "coconut pulp",
    "product.item.code.peanut-butter": "peanut butter",
    "product.item.code.spelt": "spelt",
    "product.item.code.flax-seeds": "flax seeds",
    "product.item.code.coconut-milk": "coconutmilk",
    "product.item.code.prunes": "prunes",
    "app.page.product.filters.recipeType": "recipe type",
    "product.item.code.mozzarella-cheese": "mozzarella cheese",
    "product.item.code.funchose": "funchose",
    "preference.scheme.preferenceType.combination": "combination",
    "product.item.code.red-onion": "redonion",
    "product.item.code.paprika": "paprika",
    "product.item.code.pear": "pear",
    "product.item.code.couscous": "couscous",
    "product.item.code.shrimps": "shrimps",
    "product.item.code.avocado": "avocado",
    "product.item.code.tuna": "tuna",
    "product.item.code.whole-wheat-bread": "whole wheat bread",
    "product.item.code.yogurt": "yogurt",
    "app.page.product.edit.image.base.title": "image",
    "app.page.product.edit.image.parts.title": "parts",
    "app.page.product.edit.image.base.color.label": "background color",
    "app.page.product.edit.image.base.color.placeholder": "enter color",
    "app.page.product.edit.image.parts.color.label": "parts color",
    "app.page.product.edit.image.parts.color.placeholder": "enter parts color",
    "app.page.product.edit.image.part.label": "part {0}",
    "app.page.product.edit.image.part.placeholder": "enter part path",
    "app.page.product.edit.image.part.size.min.label": "min size",
    "app.page.product.edit.image.part.size.max.label": "max size",
    "app.page.product.edit.image.part.add": "add part",
    "app.page.product.edit.image.part.viewbox.label": "viewBox",
    "app.page.product.edit.image.part.viewbox.placeholder": "enter viewBox",
    "app.page.product.edit.image.part.withoutbase.label": "Part is used without base",
    "app.page.preference.skip": "skip",
    "app.page.preference.preferencesInfo": "you can change selected preferences in tab \"Preferences\"",
    "app.page.recipe.recipeCharacteristic.product-category": "product category",
    "preference.scheme.preferenceType.macronutrient-per-meal": "macronutrient per meal",
    "preference.scheme.preferenceType.macronutrient-per-day": "macronutrient per day",
    "preference.scheme.preferenceType.product-category-per-meal": "product category per meal",
    "preference.scheme.preferenceType.product-category-per-day": "product category per day",
    "meal.scheme.unit.gram": "gram",
    "meal.scheme.unit.percentage": "percentage",
    "meal.scheme.unit.pinch": "pinch",
    "meal.scheme.unit.teaspoon": "teaspoon",
    "meal.scheme.unit.tablespoon": "tablespoon",
    "meal.scheme.unit.g-per-kg": "g/kg",
    "meal.scheme.unit.mg-per-kg": "mg/kg",
    "meal.scheme.unit.mcg-per-kg": "mcg/kg",
    "meal.scheme.unit.mg": "mg",
    "meal.scheme.unit.mcg": "mcg",
    "app.page.user.login.tg-admin-bot": "tg bot"
};
export default en;
